(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8945],{

/***/ 78693:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[[...slugs]]",
      function () {
        return __webpack_require__(64143);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ CategoryPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/antd/es/skeleton/index.js + 8 modules
var skeleton = __webpack_require__(41080);
// EXTERNAL MODULE: ./node_modules/antd/es/breadcrumb/index.js + 3 modules
var breadcrumb = __webpack_require__(58492);
// EXTERNAL MODULE: ./packages/datasource/src/api/blog/index.ts + 2 modules
var blog = __webpack_require__(41826);
// EXTERNAL MODULE: ./src/components/index.js + 20 modules
var components = __webpack_require__(21679);
// EXTERNAL MODULE: ./src/context/index.js + 3 modules
var context = __webpack_require__(62675);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
// EXTERNAL MODULE: ./node_modules/antd/es/card/index.js + 2 modules
var card = __webpack_require__(97751);
// EXTERNAL MODULE: ./src/pages/blog/_components/common.styled.js
var common_styled = __webpack_require__(75610);
;// CONCATENATED MODULE: ./src/pages/blog/_components/FeedbackCard/index.styled.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  ",
        ";\n  margin-top: 1rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  svg {\n    width: ",
        "px;\n    height: ",
        "px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  .ant-card-head-title {\n    overflow: visible;\n    white-space: unset;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var Container = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), mixins/* showOnDesktop */.Ql(), common_styled/* borderRadius */.E, mixins/* anchor */.Eu());
var iconSize = 16;
var HeaderRight = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1(), iconSize, iconSize);
var Card = (0,styled_components_browser_esm/* default */.ZP)(card/* default */.Z)(_templateObject2(), common_styled/* borderRadius */.E, mixins/* anchor */.Eu());

// EXTERNAL MODULE: ./src/components/Anchor.tsx
var Anchor = __webpack_require__(580);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons-svg/es/asn/FlagOutlined.js
// This icon file is generated automatically.
var FlagOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z" } }] }, "name": "flag", "theme": "outlined" };
/* harmony default export */ var asn_FlagOutlined = (FlagOutlined);

// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 2 modules
var AntdIcon = __webpack_require__(84089);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/FlagOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY




var FlagOutlined_FlagOutlined = function FlagOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: asn_FlagOutlined
  }));
};

FlagOutlined_FlagOutlined.displayName = 'FlagOutlined';
/* harmony default export */ var icons_FlagOutlined = (/*#__PURE__*/react.forwardRef(FlagOutlined_FlagOutlined));
;// CONCATENATED MODULE: ./src/pages/blog/_components/FeedbackCard/index.tsx





var feedbackUrl = "https://pingkai.cn/tidbcommunity/forum/t/topic/542917";
function FeedbackCard() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
            title: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderLeft, {}),
            extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeedbackCard_HeaderRight, {}),
            children: [
                "\u5982\u679C\u4F60\u5728\u4F7F\u7528\u535A\u5BA2\u7CFB\u7EDF\u65F6\u9047\u5230\u95EE\u9898\uFF0C\u6216\u8005\u60F3\u8981\u63D0\u4F9B\u5EFA\u8BAE\uFF0C\u6765 ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                    href: feedbackUrl,
                    children: "\u3010\u8FD9\u91CC\u3011"
                }),
                " \u53CD\u9988\u3002"
            ]
        })
    });
};
function HeaderLeft() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: "\u5EFA\u8BAE\u53CD\u9988\u5165\u53E3"
    });
}
function FeedbackCard_HeaderRight() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderRight, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_FlagOutlined, {})
    });
}

// EXTERNAL MODULE: ./packages/ui/src/styled.ts
var styled = __webpack_require__(78763);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
// EXTERNAL MODULE: ./packages/ui/src/constants.ts
var constants = __webpack_require__(52483);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
;// CONCATENATED MODULE: ./src/pages/blog/_components/BlogHomepage/index.styled.js
function index_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function index_styled_templateObject() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n"
    ]);
    index_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function index_styled_templateObject1() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  @media screen and (max-width: ",
        ") {\n    padding: 1rem 0;\n  }\n\n  @media screen and (min-width: ",
        ") {\n    padding: 2rem 0;\n  }\n"
    ]);
    index_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function index_styled_templateObject2() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  position: sticky !important;\n  top: ",
        "px;\n  height: 100%;\n"
    ]);
    index_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = index_styled_taggedTemplateLiteral([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  position: sticky !important;\n  top: ",
        "px;\n  height: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  padding-top: 2rem;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = index_styled_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var Content = styled/* Content */.VY;

var headerHeightPx = 56;
var topPx = headerHeightPx + 32;
var Background = styled_components_browser_esm/* default.div */.ZP.div(index_styled_templateObject(), colors.M2);
var index_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).attrs({
    gutter: 24
})(index_styled_templateObject1(), constants/* breakPoints.md */.Eg.md, constants/* breakPoints.md */.Eg.md);
var Start = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs(function(param) {
    var $forTag = param.$forTag;
    return {
        sm: 24,
        md: $forTag ? 6 : 4
    };
})(index_styled_templateObject2(), topPx);
var Center = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs(function(param) {
    var $forTag = param.$forTag;
    return {
        sm: 24,
        md: $forTag ? 12 : 14
    };
})(_templateObject3());
var End = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs({
    sm: 24,
    md: 6
})(_templateObject4(), topPx);
var Breadcrumb = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5());
var WriteBlog = styled_components_browser_esm/* default.div */.ZP.div(_templateObject6(), mixins/* showOnDesktop */.Ql());

// EXTERNAL MODULE: ./src/pages/blog/BlogLayout.component.js
var BlogLayout_component = __webpack_require__(54846);
;// CONCATENATED MODULE: ./src/pages/blog/_components/CategoryList/index.styled.js
function CategoryList_index_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CategoryList_index_styled_templateObject() {
    var data = CategoryList_index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    CategoryList_index_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CategoryList_index_styled_templateObject1() {
    var data = CategoryList_index_styled_taggedTemplateLiteral([
        ""
    ]);
    CategoryList_index_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CategoryList_index_styled_templateObject2() {
    var data = CategoryList_index_styled_taggedTemplateLiteral([
        "\n  display: block;\n  border-top-right-radius: ",
        ";\n  border-bottom-right-radius: ",
        ";\n  cursor: pointer;\n  padding: 0 1rem;\n  background-color: ",
        ";\n  border-left: ",
        ";\n  transition: color 0.25s ease;\n  color: ",
        " !important;\n  &:not(:last-child) {\n    margin-bottom: 0.5rem;\n  }\n  &:hover {\n    color: ",
        " !important;\n  }\n  height: 40px;\n  line-height: 40px;\n"
    ]);
    CategoryList_index_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function index_styled_templateObject3() {
    var data = CategoryList_index_styled_taggedTemplateLiteral([
        "\n  display: block;\n  padding: 0.25rem 1rem;\n  margin: 0.5rem 0;\n  cursor: pointer;\n  transition: color 0.25s ease;\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    index_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var CategoryList_index_styled_Container = styled_components_browser_esm/* default.div */.ZP.div(CategoryList_index_styled_templateObject(), mixins/* showOnDesktop */.Ql());
var List = styled_components_browser_esm/* default.div */.ZP.div(CategoryList_index_styled_templateObject1());
var Item = styled_components_browser_esm/* default.a */.ZP.a(CategoryList_index_styled_templateObject2(), common_styled/* borderRadiusSize */.k, common_styled/* borderRadiusSize */.k, function(props) {
    return props.selected ? colors.M1 : "";
}, function(props) {
    return props.selected ? "4px solid ".concat(colors.T7) : "none";
}, colors.F1, colors.B1);
var FixedLink = styled_components_browser_esm/* default.a */.ZP.a(index_styled_templateObject3(), colors.B1);

// EXTERNAL MODULE: ./node_modules/antd/es/divider/index.js
var divider = __webpack_require__(27049);
// EXTERNAL MODULE: ./src/pages/blog/blog.hooks.js
var blog_hooks = __webpack_require__(99117);
;// CONCATENATED MODULE: ./src/pages/blog/_components/CategoryList/CategoryList.component.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var CategoryList = function(param) {
    var content = param.categories.content, _shallow = param.shallow, shallow = _shallow === void 0 ? false : _shallow, current = param.current, type = param.type;
    var hasAuthority = (0,blog_hooks/* usePrincipal */.j)().hasAuthority;
    var showAudits = hasAuthority("REVIEW_POST");
    var ref = (0,react.useContext)(context/* MeContext */.io), meData = ref.meData, isMeValidating = ref.isMeValidating;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryList_index_styled_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(List, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryList_component_Item, {
                        name: "\u5168\u90E8\u6587\u7AE0",
                        slug: "",
                        active: type === "all",
                        shallow: shallow
                    }, ""),
                    content.map(function(value) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryList_component_Item, _objectSpread({}, value, {
                            shallow: shallow,
                            active: current === value.slug
                        }), value.slug);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(divider/* default */.Z, {}),
            showAudits && /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink, {
                href: "/blog/audits",
                children: "\u5F85\u5BA1\u6838"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    (meData === null || meData === void 0 ? void 0 : meData.username) && !isMeValidating && /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryList_component_FixedLink, {
                        href: "/u/".concat(meData === null || meData === void 0 ? void 0 : meData.username),
                        children: "\u6211\u7684\u535A\u5BA2"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryList_component_FixedLink, {
                        href: "https://pingkai.cn/tidbcommunity/blog/66c5e81b",
                        children: "\u535A\u5BA2\u53D1\u5E03\u6307\u5357"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryList_component_FixedLink, {
                        href: "https://www.pingcap.cn/privacy-policy",
                        children: "\u9690\u79C1\u534F\u8BAE"
                    })
                ]
            })
        ]
    });
};
var CategoryList_component_Item = function(param) {
    var name = param.name, slug = param.slug, shallow = param.shallow, active = param.active;
    var url = slug === "" ? "/blog" : "/blog/c/".concat(slug);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: url,
        passHref: true,
        shallow: shallow,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
            selected: active,
            children: name
        })
    });
};
var CategoryList_component_FixedLink = function(param) {
    var href = param.href, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FixedLink, {
        href: href,
        target: "_blank",
        rel: "noreferrer noopener",
        children: children
    });
};
var NextLink = function(param) {
    var href = param.href, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FixedLink, {
            children: children
        })
    });
};
/* harmony default export */ var CategoryList_component = (CategoryList);

;// CONCATENATED MODULE: ./src/pages/blog/_components/CategoryList/index.js

/* harmony default export */ var _components_CategoryList = (CategoryList_component);

;// CONCATENATED MODULE: ./src/pages/blog/_components/CategoryListMobile/index.styled.js
function CategoryListMobile_index_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CategoryListMobile_index_styled_templateObject() {
    var data = CategoryListMobile_index_styled_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    CategoryListMobile_index_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CategoryListMobile_index_styled_templateObject1() {
    var data = CategoryListMobile_index_styled_taggedTemplateLiteral([
        "\n  display: flex;\n  overflow: scroll;\n  // code at below is for hidden scroll on different browser\n  scrollbar-width: none; /* firefox */\n  -ms-overflow-style: none; /* IE 10+ */\n  &::-webkit-scrollbar {\n    display: none; /* Chrome Safari */\n  }\n"
    ]);
    CategoryListMobile_index_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CategoryListMobile_index_styled_templateObject2() {
    var data = CategoryListMobile_index_styled_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  display: block;\n  padding: 0.125rem 0.5rem;\n  margin: 0.5rem 0.25rem;\n  border-radius: 0.25rem;\n  border: 1px solid ",
        ";\n  font-size: 14px;\n  white-space: nowrap;\n  background-color: ",
        ";\n  border-color: ",
        ";\n  color: ",
        ";\n\n  &:hover {\n    background-color: ",
        ";\n    color: ",
        ";\n    border-color: ",
        ";\n  }\n"
    ]);
    CategoryListMobile_index_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var CategoryListMobile_index_styled_Container = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({})(CategoryListMobile_index_styled_templateObject(), mixins/* showOnMobile */.gG());
var index_styled_List = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs({})(CategoryListMobile_index_styled_templateObject1());
var index_styled_Item = styled_components_browser_esm/* default.a */.ZP.a(CategoryListMobile_index_styled_templateObject2(), colors.C4, colors.C4, function(props) {
    return props.selected ? colors.B1 : "";
}, function(props) {
    return props.selected ? colors.B1 : colors.C4;
}, function(props) {
    return props.selected ? colors.C2 : colors.C4;
}, colors.B1, colors.C2, colors.C2);

;// CONCATENATED MODULE: ./src/pages/blog/_components/CategoryListMobile/CategoryListMobile.component.js
function CategoryListMobile_component_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CategoryListMobile_component_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CategoryListMobile_component_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var CategoryListMobile = function(param) {
    var content = param.categories.content, current = param.current, shallow = param.shallow, type = param.type;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryListMobile_index_styled_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_styled_List, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryListMobile_component_Item, {
                    name: "\u5168\u90E8\u6587\u7AE0",
                    slug: "",
                    active: type === "all",
                    shallow: shallow
                }, ""),
                content.map(function(value, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryListMobile_component_Item, CategoryListMobile_component_objectSpread({}, value, {
                        shallow: shallow,
                        active: current === value.slug
                    }), index);
                })
            ]
        })
    });
};
var CategoryListMobile_component_Item = function(param) {
    var name = param.name, slug = param.slug, shallow = param.shallow, active = param.active;
    var url = slug === "" ? "/blog" : "/blog/c/".concat(slug);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: url,
        passHref: true,
        shallow: shallow,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_Item, {
            selected: active,
            children: name
        })
    });
};
/* harmony default export */ var CategoryListMobile_component = (CategoryListMobile);

;// CONCATENATED MODULE: ./src/pages/blog/_components/CategoryListMobile/index.js

/* harmony default export */ var _components_CategoryListMobile = (CategoryListMobile_component);

;// CONCATENATED MODULE: ./src/pages/blog/_components/OrderBySwitch/index.styled.js
function OrderBySwitch_index_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function OrderBySwitch_index_styled_templateObject() {
    var data = OrderBySwitch_index_styled_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 40px;\n  margin-bottom: 16px;\n"
    ]);
    OrderBySwitch_index_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OrderBySwitch_index_styled_templateObject1() {
    var data = OrderBySwitch_index_styled_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n"
    ]);
    OrderBySwitch_index_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function OrderBySwitch_index_styled_templateObject2() {
    var data = OrderBySwitch_index_styled_taggedTemplateLiteral([
        "\n  cursor: pointer;\n  margin: 0 0.5rem;\n  color: ",
        ";\n  border-bottom: ",
        ";\n"
    ]);
    OrderBySwitch_index_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function OrderBySwitch_index_styled_templateObject3() {
    var data = OrderBySwitch_index_styled_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    OrderBySwitch_index_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var OrderBySwitch_index_styled_Container = styled_components_browser_esm/* default.div */.ZP.div(OrderBySwitch_index_styled_templateObject());
var OrderBySwitch_index_styled_List = styled_components_browser_esm/* default.div */.ZP.div(OrderBySwitch_index_styled_templateObject1());
var OrderBySwitch_index_styled_Item = styled_components_browser_esm/* default.div */.ZP.div(OrderBySwitch_index_styled_templateObject2(), function(props) {
    return props.selected ? colors.B1 : "";
}, function(props) {
    return props.selected ? "4px solid ".concat(colors.B1) : "none";
});
var AllTag = styled_components_browser_esm/* default.div */.ZP.div(OrderBySwitch_index_styled_templateObject3(), mixins/* showOnMobile */.gG());

;// CONCATENATED MODULE: ./src/pages/blog/_components/OrderBySwitch/OrderBySwitch.component.js
function OrderBySwitch_component_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function OrderBySwitch_component_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            OrderBySwitch_component_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var OrderBySwitch = function(param) {
    var items = param.items, _shallow = param.shallow, shallow = _shallow === void 0 ? false : _shallow;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(OrderBySwitch_index_styled_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderBySwitch_index_styled_List, {
                children: items.map(function(value, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderBySwitch_component_Item, OrderBySwitch_component_objectSpread({}, value), index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AllTag, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/blog/tag",
                    shallow: shallow,
                    children: "\u5168\u90E8\u6807\u7B7E"
                })
            })
        ]
    });
};
var OrderBySwitch_component_Item = function(param) {
    var name = param.name, url = param.url;
    var asPath = (0,next_router.useRouter)().asPath;
    var selected = asPath === url;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: url,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderBySwitch_index_styled_Item, {
            selected: selected,
            children: name
        })
    });
};
/* harmony default export */ var OrderBySwitch_component = (OrderBySwitch);

;// CONCATENATED MODULE: ./src/pages/blog/_components/OrderBySwitch/index.js

/* harmony default export */ var _components_OrderBySwitch = (OrderBySwitch_component);

// EXTERNAL MODULE: ./src/pages/blog/_components/BlogList/index.js + 5 modules
var BlogList = __webpack_require__(39264);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/EditOutlined.js + 1 modules
var EditOutlined = __webpack_require__(86548);
// EXTERNAL MODULE: ./src/utils/index.js + 2 modules
var utils = __webpack_require__(49714);
;// CONCATENATED MODULE: ./src/pages/blog/_components/WriteBlogButton/index.js









var WriteBlogButton = function() {
    var router = (0,next_router.useRouter)();
    var isLogin = (0,blog_hooks/* usePrincipal */.j)().isLogin;
    var login = (0,react.useContext)(context/* AuthContext */.Vo).login;
    var handleClickWrite = function(e) {
        e.preventDefault();
        if (!isLogin) {
            login();
        } else {
            utils/* link.handleRedirect */.p4.handleRedirect(router, "/blog/new/edit");
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditOutlined/* default */.Z, {}),
        onClick: handleClickWrite,
        type: "primary",
        block: true,
        children: "\u5199\u6587\u7AE0"
    });
};
/* harmony default export */ var _components_WriteBlogButton = (WriteBlogButton);

;// CONCATENATED MODULE: ./src/pages/blog/_components/HotTagList/index.styled.js
function HotTagList_index_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function HotTagList_index_styled_templateObject() {
    var data = HotTagList_index_styled_taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n  margin: 1rem 0;\n  .ant-card-head a {\n    color: ",
        ";\n  }\n"
    ]);
    HotTagList_index_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HotTagList_index_styled_templateObject1() {
    var data = HotTagList_index_styled_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    HotTagList_index_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HotTagList_index_styled_templateObject2() {
    var data = HotTagList_index_styled_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n"
    ]);
    HotTagList_index_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HotTagList_index_styled_templateObject3() {
    var data = HotTagList_index_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  display: block;\n  cursor: pointer;\n  margin: 0.5rem;\n  color: ",
        ";\n"
    ]);
    HotTagList_index_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var HotTagList_index_styled_Container = styled_components_browser_esm/* default.div */.ZP.div(HotTagList_index_styled_templateObject(), mixins/* showOnDesktop */.Ql(), common_styled/* borderRadius */.E, colors.B1);
var index_styled_Card = (0,styled_components_browser_esm/* default */.ZP)(card/* default */.Z)(HotTagList_index_styled_templateObject1(), common_styled/* borderRadius */.E);
var HotTagList_index_styled_List = styled_components_browser_esm/* default.div */.ZP.div(HotTagList_index_styled_templateObject2());
var HotTagList_index_styled_Item = styled_components_browser_esm/* default.a */.ZP.a(HotTagList_index_styled_templateObject3(), common_styled/* borderRadius */.E, function(props) {
    return props.selected ? colors.B1 : "";
});

;// CONCATENATED MODULE: ./src/pages/blog/_components/HotTagList/HotTagList.component.js
function HotTagList_component_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function HotTagList_component_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            HotTagList_component_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var HotTagList = function(param) {
    var content = param.hotTags.content, _shallow = param.shallow, shallow = _shallow === void 0 ? false : _shallow, current = param.current;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(HotTagList_index_styled_Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled_Card, {
            title: "\u70ED\u95E8\u6807\u7B7E",
            extra: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/blog/tag",
                children: "\u67E5\u770B\u5168\u90E8"
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HotTagList_index_styled_List, {
                children: content.map(function(item) {
                    return /*#__PURE__*/ (0,react.createElement)(HotTagList_component_Item, HotTagList_component_objectSpread({}, item, {
                        key: item.id,
                        shallow: shallow,
                        current: current,
                        active: current === item.slug
                    }));
                })
            })
        })
    });
};
var HotTagList_component_Item = function(param) {
    var name = param.name, slug = param.slug, shallow = param.shallow, active = param.active;
    var url = "/blog/tag/".concat(slug);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: url,
        passHref: true,
        shallow: shallow,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HotTagList_index_styled_Item, {
            selected: active,
            children: [
                "# ",
                name
            ]
        })
    });
};
/* harmony default export */ var HotTagList_component = (HotTagList);

;// CONCATENATED MODULE: ./src/pages/blog/_components/HotTagList/index.js

/* harmony default export */ var _components_HotTagList = (HotTagList_component);

;// CONCATENATED MODULE: ./src/pages/blog/_components/BlogHomepage/utils.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var parseSlugs = function(slugs, latest) {
    if (!(slugs === null || slugs === void 0 ? void 0 : slugs.length)) {
        // url: /blog
        return {
            latest: Boolean(latest),
            type: "all",
            slug: ""
        };
    } else {
        var _slugs = _slicedToArray(slugs, 2), type = _slugs[0], slug = _slugs[1];
        if (slugs.length === 2) {
            switch(type){
                case "c":
                    return {
                        latest: Boolean(latest),
                        type: "category",
                        slug: slug
                    };
                case "tag":
                    return {
                        latest: Boolean(latest),
                        type: "tag",
                        slug: slug
                    };
                default:
                    break;
            }
        }
    }
    return false;
};

// EXTERNAL MODULE: ./src/pages/blog/tag/TagItem.component.js + 1 modules
var TagItem_component = __webpack_require__(93829);
;// CONCATENATED MODULE: ./src/pages/blog/[[...slugs]].page.js
function _slugs_page_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _slugs_page_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _slugs_page_defineProperty(target, key, source[key]);
        });
    }
    return target;
}















// import SearchOnMobile from './_components/SearchOnMobile';






var CATEGORY_ALL = {
    name: "\u9996\u9875",
    slug: ""
};
var __N_SSP = true;
function CategoryPage(param) {
    var categoryFromSSR = param.category, categoriesFromSSR = param.categories, blogsFromSSR = param.blogs, tagFromSSR = param.tag, hotTagsFromSSR = param.hotTags;
    var router = (0,next_router.useRouter)();
    var _query = router.query, slugs = _query.slugs, queryLatest = _query.latest;
    var info = (0,react.useMemo)(function() {
        return parseSlugs(slugs, queryLatest);
    }, [
        slugs,
        queryLatest
    ]);
    var ref = (0,dist/* default */.ZP)(info.slug === "category" ? [
        "blog.getCategoryBySlug",
        info
    ] : null, {
        fallbackData: info.type === "all" ? CATEGORY_ALL : categoryFromSSR,
        revalidateOnMount: true
    }), category = ref.data, categoryError = ref.error;
    var ref1 = (0,dist/* default */.ZP)(info.type === "tag" ? [
        "blog.getTagBySlug",
        info
    ] : null, {
        fallbackData: tagFromSSR,
        revalidateOnMount: true
    }), tag = ref1.data, tagError = ref1.error;
    var ref2 = (0,dist/* default */.ZP)([
        "blog.getCategories",
        JSON.stringify({})
    ], {
        fallbackData: categoriesFromSSR,
        revalidateOnMount: true
    }), categories = ref2.data, categoriesError = ref2.error;
    var ref3 = (0,dist/* default */.ZP)([
        "blog.getHotTags",
        JSON.stringify({})
    ], {
        fallbackData: hotTagsFromSSR,
        revalidateOnMount: true
    }), hotTags = ref3.data, hotTagsError = ref3.error;
    var ref4 = (0,react.useState)(category || tag), filter1 = ref4[0], setFilter = ref4[1];
    (0,react.useEffect)(function() {
        if (!info) {
            return;
        }
        if (info.slug === "") {
            setFilter(CATEGORY_ALL);
        } else {
            var filter;
            switch(info.type){
                case "category":
                    filter = categories.content.find(function(c) {
                        return c.slug === info.slug;
                    });
                    break;
                case "tag":
                    filter = hotTags.content.find(function(t) {
                        return t.slug === info.slug;
                    });
                    break;
                default:
                    filter = CATEGORY_ALL;
                    break;
            }
            if (filter) {
                setFilter(filter);
            }
        }
    }, [
        info,
        categories,
        hotTags
    ]);
    (0,react.useEffect)(function() {
        if (info) {
            switch(info.type){
                case "tag":
                    setFilter(function(filter) {
                        if ((tag === null || tag === void 0 ? void 0 : tag.slug) === (info === null || info === void 0 ? void 0 : info.slug)) {
                            return tag;
                        } else {
                            return filter;
                        }
                    });
                    break;
                case "category":
                    setFilter(function(filter) {
                        if ((category === null || category === void 0 ? void 0 : category.slug) === (info === null || info === void 0 ? void 0 : info.slug)) {
                            return category;
                        } else {
                            return filter;
                        }
                    });
                    break;
            }
        }
    }, [
        info,
        tag,
        category
    ]);
    var orderBy = (0,react.useMemo)(function() {
        if (!info) {
            return [];
        }
        if (info.slug) {
            switch(info.type){
                case "category":
                    return [
                        {
                            name: "\u63A8\u8350\u6392\u5E8F",
                            url: "/blog/c/".concat(info.slug)
                        },
                        {
                            name: "\u65F6\u95F4\u6392\u5E8F",
                            url: "/blog/c/".concat(info.slug, "?latest=true")
                        }, 
                    ];
                case "tag":
                    return [
                        {
                            name: "\u63A8\u8350\u6392\u5E8F",
                            url: "/blog/tag/".concat(info.slug)
                        },
                        {
                            name: "\u65F6\u95F4\u6392\u5E8F",
                            url: "/blog/tag/".concat(info.slug, "?latest=true")
                        }, 
                    ];
                default:
                    return [];
            }
        } else {
            return [
                {
                    name: "\u63A8\u8350\u6392\u5E8F",
                    url: "/blog"
                },
                {
                    name: "\u65F6\u95F4\u6392\u5E8F",
                    url: "/blog?latest=true"
                }, 
            ];
        }
    }, [
        info
    ]);
    var error = categoryError || categoriesError || tagError || hotTagsError;
    var loading = !categories && !hotTags;
    if (!info) return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ErrorPage */.mf, {
        statusCode: 404
    });
    if (error) {
        console.error(error);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ErrorPage */.mf, {
            error: error
        });
    }
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
        active: true
    });
    var ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(context/* PageDataContext.Provider */.A6.Provider, {
        value: {
            showRecommendedIcon: true
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CommunityHead */.Wh, {
                title: (filter1 === null || filter1 === void 0 ? void 0 : filter1.name) == null ? "\u535A\u5BA2" : "\u535A\u5BA2 - ".concat(filter1 === null || filter1 === void 0 ? void 0 : filter1.name),
                description: "\u8FD9\u91CC\u6709\u6765\u81EA TiDB \u793E\u533A\u7528\u6237\u5206\u4EAB\u7684\u7BA1\u7406\u4E0E\u8FD0\u7EF4\u3001\u5B9E\u8DF5\u6848\u4F8B\u3001\u67B6\u6784\u9009\u578B\u3001\u539F\u7406\u89E3\u8BFB\u3001\u5E94\u7528\u5F00\u53D1\u3001\u793E\u533A\u52A8\u6001\u7B49\u4E00\u7CFB\u5217\u6280\u672F\u6587\u7AE0\uFF0C\u4E5F\u671F\u5F85\u4F60\u7684\u5206\u4EAB~"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogLayout_component/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                    children: [
                        info.type === "tag" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(breadcrumb/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb/* default.Item */.Z.Item, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/blog",
                                            shallow: true,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: "\u535A\u5BA2"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb/* default.Item */.Z.Item, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/blog/tag",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: "\u6807\u7B7E"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb/* default.Item */.Z.Item, {
                                        children: (ref5 = tag === null || tag === void 0 ? void 0 : tag.name) !== null && ref5 !== void 0 ? ref5 : "\u52A0\u8F7D\u4E2D..."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_styled_Container, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Start, {
                                    $forTag: info.type === "tag",
                                    children: info.type === "tag" ? tag ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TagItem_component/* default */.Z, _slugs_page_objectSpread({}, tag)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                                        active: true
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(_components_CategoryList, {
                                        categories: categories,
                                        shallow: true,
                                        current: info.type === "category" && info.slug,
                                        type: info.type
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Center, {
                                    $forTag: info.type === "tag",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(_components_CategoryListMobile, {
                                            categories: categories,
                                            shallow: true,
                                            current: info.type === "category" && info.slug,
                                            type: info.type
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(_components_OrderBySwitch, {
                                            items: orderBy,
                                            shallow: true
                                        }),
                                        filter1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogList/* BlogListInfiniteScroll */.j, {
                                            blogs: blogsFromSSR,
                                            api: blog.getPostList,
                                            params: _slugs_page_defineProperty({
                                                latest: info.latest
                                            }, "".concat(info.type, "ID"), filter1.id)
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* default */.Z, {
                                            active: true
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(End, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(WriteBlog, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(_components_WriteBlogButton, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(_components_HotTagList, {
                                            hotTags: hotTags,
                                            shallow: true,
                                            current: info.type === "tag" && info.slug
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FeedbackCard, {})
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 93829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TagItem_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
// EXTERNAL MODULE: ./node_modules/antd/es/card/index.js + 2 modules
var card = __webpack_require__(97751);
// EXTERNAL MODULE: ./src/pages/blog/_components/common.styled.js
var common_styled = __webpack_require__(75610);
;// CONCATENATED MODULE: ./src/pages/blog/tag/TagItem.styled.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  transition: all 250ms;\n  box-shadow: none;\n  &:hover {\n    box-shadow: 0 2px 6px 0 ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  a {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n  margin-top: 1rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  color: ",
        ";\n  margin-top: 1rem;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var Card = (0,styled_components_browser_esm/* default */.ZP)(card/* default */.Z)(_templateObject(), common_styled/* borderRadius */.E, colors.C2);
var Title = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1(), mixins/* typography */.cp("h3"), colors.F1);
var Description = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2(), mixins/* lineClamp */.Sf(3), mixins/* typography */.cp("p2"));
var Footer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3(), mixins/* typography */.cp("p2"), colors.C4);

;// CONCATENATED MODULE: ./src/pages/blog/tag/TagItem.component.js




var TagItem = function(param) {
    var name = param.name, slug = param.slug, posts = param.posts;
    var url = "/blog/tag/".concat(slug);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
        title: "",
        bordered: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: url,
                    children: "# ".concat(name)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer, {
                children: [
                    posts !== null && posts !== void 0 ? posts : 0,
                    " \u7BC7\u6587\u7AE0"
                ]
            })
        ]
    });
};
/* harmony default export */ var TagItem_component = (TagItem);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7427,6465,9569,3414,9774,2888,179], function() { return __webpack_exec__(78693); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);